<template>
  <b-navbar type="dark" variant="dark" toggleable="xl" id="v-step-0">
    <b-navbar-brand :href="OOIURL" id="navbar_brand">
      <img :src="LOGO2" class="d-inline-block align-top" alt="OOI Logo">
    </b-navbar-brand>
    <b-popover
      target="navbar_brand"
      triggers="hover"
      placement="bottomright"
      title="Website homepage">
      The homepage of the interactive oceans website.
    </b-popover>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item id="navbar_home" :to="{ path: '/' }"
          @click="getNavID">
          <i class="fas fa-home"></i>
          Home
        </b-nav-item>
        <b-popover
          target="navbar_home"
          triggers="hover"
          placement="bottomright"
          title="Data portal homepage">
          The homepage of the interactive oceans data portal.
        </b-popover>
        <b-nav-item id="navbar_map" :to="{ path: '/map' }"
          @click="getNavID">
          <i class="fas fa-globe-americas"></i>
          Interactive Map
        </b-nav-item>
        <b-popover
          target="navbar_map"
          triggers="hover"
          placement="bottomright"
          title="Map exploration page">
          A window to explore instruments and features on the seafloor.
        </b-popover>
        <!-- <b-nav-item id="navbar_plot" :to="{ path: '/plot' }"
          @click="getNavID">
          <i class="fas fa-chart-line"></i>
          Data Visualization
        </b-nav-item>
        <b-popover
          target="navbar_plot"
          triggers="hover"
          placement="bottomright"
          title="Data visualization page">
          A tool to visualize and analyze historic and recent oceanographic datasets.
        </b-popover> -->
        <b-nav-item id="navbar_data_info" :to="{ path: '/data-info' }"
          @click="getNavID">
          <i class="fas fa-cloud"></i>
          Data Information
        </b-nav-item>
        <b-popover
          target="navbar_data_info"
          triggers="hover"
          placement="bottomright"
          title="Data information page">
          A way to explore the underlying metadata of OOI datasets on the cloud.
        </b-popover>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown text="Data Gallery" id="navbar_data_gallery">
          <b-dropdown-item :href="notebookGallery" id="navbar_notebook_gallery" target='_blank'
            @click="getNavID">
            <i class="fab fa-github"></i>
            Notebook Gallery
          </b-dropdown-item>
          <b-dropdown-item :href="oceanSciencesNotebook" id="navbar_OS_notebook" target='_blank'
            @click="getNavID">
            <i class="fab fa-github"></i>
            Ocean Science Notebook
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-popover
          target="navbar_data_gallery"
          triggers="hover"
          placement="bottomleft"
          title="Data gallery">
          A set of Jupyter notebooks and other tools that utilize data from the Regional
          Cabled Array for exploration of ocean data science.
        </b-popover>

        <b-nav-item-dropdown text="Resources" id="navbar_resources">
          <b-dropdown-item :href="OOIURLRA" id="navbar_reserach_sites" target='_blank'
            @click="getNavID">
            <i class="fas fa-map-marker-alt"></i>
            Research Sites
          </b-dropdown-item>
          <b-dropdown-item :href="OOIURLInstruments" id="navbar_instruments_page" target='_blank'
            @click="getNavID">
            <i class="fas fa-broadcast-tower"></i>
            Instrument Pages
          </b-dropdown-item>
          <b-dropdown-item :href="resourcesSites" id="navbar_data_resources" target='_blank'
            @click="getNavID">
            <i class="fab fa-github"></i>
            Data Resources
          </b-dropdown-item>
          <b-dropdown-item :href="OOIURLGlossary" id="navbar_glossary" target='_blank'
            @click="getNavID">
            <i class="fas fa-book"></i>
            Glossary
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-popover
          target="navbar_resources"
          triggers="hover"
          placement="bottomleft"
          title="Resources">
          Resources that give context to the sites, infrastructures, instruments and
          vocabulary regarding the Regional Cabled Array.
        </b-popover>

        <b-nav-item id="navbar_contact" :href="OOIURLContact" target='_blank'
          @click="getNavID">
          <i class="fas fa-pen-square"></i>
           Contact
        </b-nav-item>
        <b-popover
          target="navbar_contact"
          triggers="hover"
          placement="bottomleft"
          title="Contact form">
          A form to send the team your questions, comments and feedback.
        </b-popover>
        <b-nav-item id="navbar_tour-button" @click="tourStart()">
          <i class="fas fa-compass"></i>
           Take a tour
        </b-nav-item>
        <b-popover
          target="navbar_tour-button"
          triggers="hover"
          placement="bottomleft"
          title="Take a tour">
          Click to start the current page's tour.
        </b-popover>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
/** Gets the OOI RCA logo image to display on top of menu */
import LOGO2 from '../../assets/img/ooi-rsn-logo.png';

export default {
  data() {
    return {
      LOGO2,
      tourButton: false,
      notebookGallery: `${process.env.JUPYTER}`,
      oceanSciencesNotebook: `${process.env.JUPYTERNOTEBOOK}`,
      OOIURL: `${process.env.OOIURL}`,
      OOIURLRA: `${process.env.OOIURL}/research-sites`,
      OOIURLInstruments: `${process.env.OOIURL}/instruments`,
      OOIURLContact: `${process.env.OOIURL}/contact`,
      resourcesSites: `${process.env.DATARESOURCES}`,
      OOIURLGlossary: `${process.env.OOIURL}/glossary`,
      tourMap: {
        Home: 'homeTour',
        MapApplication: 'mapTour',
        VisualizationPortal2: 'vizTour',
        PlotDetails: 'vizDetailsTour',
      },
    };
  },
  methods: {
    tourStart() {
      const { currentRoute } = this.$router;
      const routeName = currentRoute.name;
      this.$tours[this.tourMap[routeName]].start();
    },
    /** Gets the ID of the clicked element for GA event */
    getNavID(event) {
      this.$ga('event', event.target.id);
    },
    /**
     * Both title and content specified as a function in this example
     * will be called each time the popover is opened
     */
    downloadHoverContent() {
      return {
        html: true,
        title: () => 'Data Download Disclaimer',
        content: () => 'The data download functionality is currently limited to a maximum of 8 months of data at a time. If a longer time range is needed, access via <a target="_blank" href="https://dataexplorer.oceanobservatories.org/">OOI Data Explorer.</a>',
      };
    },
  },
};
</script>

<style>
.popover.b-popover{
  z-index: 2000;
}
</style>
